/**
 * 英语（en）
 */

export default {
  common: {
    default: 'Default',
    delete: 'Delete',
    cancel: 'Cancel',
    submit: 'Submit',
    inputContent: 'Input Content',
    selectContent: 'Select Content',
    pleaseEnter: 'Please Enter',
    confirm: 'Confirm',
    Warning: 'Warning',
    success: 'Success',
    next: 'next'
  },
  // 支付
  payment: {
    payment: 'Payment',
    availableBalance: 'Available Balance',
    topUp: 'Top Up',
    creditCard: 'Credit Card',
    settings: 'settings',
    transactions: 'Transactions',
    paymentMethods: 'Payment Methods',
    type: 'Type',
    orderNumber: 'Order Number',
    amount: 'Amount',
    transactionTime: 'Transaction Time',
    allType: 'Types',
    expenditure: 'Expenditure',
    income: 'Income',
    balance: 'Balance',
    refund: 'Refund',
    sample: 'Sample',
    purchase: 'Purchase',
    orderGoods: 'Order Goods',
    cardNo: 'Card No',
    expireDate: 'Expire Date',
    addCard: 'Add Card',
    startDate: 'Start Date',
    endDate: 'End Date',
    export: 'Export',
    enterAmount: 'Please enter the amount',
    dropshipping: 'Dropshipping',
    recharge: 'recharge',
    orderDeposit: 'order deposit',
    orderBalance: 'order balance',
    systemTopup: 'System top-up',
    giftCard: 'Gift card'
  },
  // 地址
  address: {
    address: 'Address',
    editTheAddress: 'Edit the Address',
    setAsDefault: 'Set as default',
    addAddress: 'Add A New Address',
    editShippingAddress: 'Edit Shipping Address',
    addShippingAddress: 'Add Shipping Address',
    editBillingAddress: 'Edit Bill Address',
    addBillingAddress: 'Add Bill Address',
    fullName: 'Full Name',
    phoneNumber: 'Phone Number',
    streetAddressLine1: 'Street Address Line 1',
    streetAddressLine2: 'Street Address Line 2',
    city: 'City',
    state: 'State',
    provice: 'Provice',
    region: 'Region',
    country: 'Country',
    countryRegion: 'Country/Region',
    zipCode: 'Zip Code',
    vat: 'VAT',
    setAsDefaultAddress: 'Set as default address',
    defaultAddress: 'Default Address',
    stateProviceRegion: 'State/Province/Region',
    deleteTip: 'Are you sure delete this address?'
  },
  // 店铺
  store: {
    store: 'Store',
    stores: 'Stores',
    allStores: 'All Stores',
    storeTips: 'Once your store is added, you can publish tens of thousands of on-trend items on your store with only a few clicks. KakaClo will take care of everything else for you after an order is placed on your store.',
    allowStoreBinding: 'Allow Store Binding',
    connectANewStore: 'Connect A New Store',
    authorized: 'Authorized',
    unauthorized: 'Unauthorized',
    reauthorize: 'Reauthorize',
    storeSettings: 'Store Settings',
    removeStoreTitle: 'Are you sure you want to remove this store?',
    removeStoreTips: 'If you just want to stop synchronizing store data to our platform and keep your store settings, you can deactivate the store instead of removing it.',
    removeStoreTips1: 'After the store is removed, the following data associated with the store will also be removed and cannot be recovered:',
    listings: 'Listings',
    OrdersOfstore: 'Orders оf the store.',
    removeTheStore: 'Remove the Store',
    storeUrl: 'Store URL',
    openStoreMsg: 'Congratulations activation, you will get the order of your bound store!',
    closeStoreAlert: 'Are you sure you want to deactivate the store?',
    closeStoreTips: 'You will not be able to get orders after the store is disabled',
    closeStoreMsg: 'You have closed your store, you can reopen the shop to receive orders',
    chooseStoreTip: "Choose your store's platform.",
    addStoreTip: 'Enter ONLY ',
    addStoreTip2: 'Your-Default-Domain',
    shopifyTips: 'Log in to your Shopify Admin to find your default domain.',
    shopifyTips1: 'www.Your-Default-Domain.myshopify.com',
    shoplazzaTips: 'Log in to your Shoplazza Admin to find your default domain.',
    shoplazzaTips1: 'www.Your-Default-Domain.shoplazza.com',
    shoplineTips: 'Log in to your Shopline Admin to find your default domain.',
    shoplineTips1: 'www.Your-Default-Domain.shopline.com',
    eg: 'e.g. ',
    addStoreVideoTip: 'How to connect a new store'
  },
  // 店铺设置
  storeSetting: {
    storeStting: 'Store Setting',
    storeName: 'Store Name',
    whetherToAuthorize: 'Whether to authorize',
    storeLink: 'Store Link',
    taxRuleTitle: 'Make the product taxable',
    taxRuleTip: 'Specifies whether a tax will be charged or not when the product variant is sold.',
    productNationalRules: 'National Rules',
    productNationalRulesTip: 'When newly released products arrive at the store, the Receiving country defaults to',
    productRules: 'Product Rules',
    productRuleTip: 'Choose an action when the inventory of the item connected to your store sku changes.',
    productRuleTip1: 'Whenever an item is not available on Kakaclo:',
    dontDealWidth: "Don't deal with",
    dontDealWidth1: 'Set the inventory amount to 0 for the specific item',
    productRuleY: 'Update Store SKU Inventory Automatically',
    productRuleY1: 'Archive or Delete',
    productRuleYHint1: 'Archive the item if it is an unavailable SPU (Stock Keeping Unit) or delete the item if it is an unavailable SKU (Stock Keeping Unit).',
    productRuleYHint2: 'By setting the inventory amount to 0, you indicate that the item is out of stock or unavailable for purchase. This helps to manage your inventory accurately and prevents customers from ordering items that are currently unavailable.',
    productRuleYHint3: 'Archiving an item means it is temporarily removed from active listings but can be reinstated in the future if the item becomes available again. On the other hand, deleting an item means it is permanently removed from your listings and cannot be restored.',
    productRuleYHint4: 'It only takes effect when the shipping method name set by your store is consistent with KakaClo. If it is inconsistent, the system defaults to Express; the shipping method names supported by KakaClo: 1. Standard; 2. Express; 3. Expedited',
    productRuleYHint5: 'When kakaclo product information changes and obtain the latest information from kakaclo, update the following information:',
    priceRules: 'Price Rules',
    changeField1: 'Product Title',
    changeField2: 'Description',
    changeField3: 'Size Chart',
    changeField4: 'Variants',
    changeField5: 'Images',
    storeCurrency: 'Store Currency',
    compareAtPrice: 'Compare at Price',
    price: 'Price',
    originalPrice: 'Suggested Price ',
    multiplier: 'Multiplier',
    shipping: 'Shipping Cost',
    orderRules: 'Order Rules',
    orderRulesTip1: "When the store's order delivery supplier delivers the goods, please select an action.",
    orderRulesY: 'Automatically upload the logistics order number to the store',
    orderRulesTip2: 'When your store receives a new waiting order, please place the order automatically.',
    orderRulesTip2N: 'Not automatically purchased',
    orderRulesTip2Y: 'Purchase automatically',
    save: 'Save',
    selectCurrency: 'Select Currency',
    productCost: 'Product Cost',
    orderRulesYTip: 'Before using this rule, please go to shopify to set up automatic shipping'
  },

  // 注册身份
  signupUser: {
    questionTile: 'How would you describe yourself in the fashion business?',
    answer1: 'I am an online seller',
    answer2: 'I am a brick-and-mortar seller',
    answer3: 'I am an Omni-channel seller',
    answer4: 'I am an influencer',
    answer5: 'I am a customer',
    answer6: 'Other'
  },
  // my information
  myInformation: {
    myInformation: 'My Information'
  }
}

